import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';

export const AdminLayout = () => {
  return (
    <div className="admin-area">
      {/* Mobile tab nav */}
      <div className="admin-tabs-mobile">
        <AdminSidebar variant="tabs" />
      </div>

      <div
        className="flex"
        style={{
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        {/* Desktop sidebar */}
        <div className="admin-sidebar-desktop" style={{ alignSelf: 'stretch' }}>
          <AdminSidebar variant="sidebar" />
        </div>

        <div style={{ flex: 1, backgroundColor: 'var(--bg-page)', minWidth: 0 }}>
          <main
            className="admin-main-content"
            style={{
              padding: 'var(--space-6) var(--space-6)',
              maxWidth: '1200px',
              minWidth: 0,
            }}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};
